import Vue from "vue";

import Router from "vue-router";

import Layout from "@/layout/index.vue";

import {

  getToken,

  setToken,

  removeToken,

  getStoreId,

  setStoreId,

  removeStoreId,

  setUserInfo,

  getUserInfo,

  removeUserInfo

} from "@/utils/cookies";

import store from "@/store";



Vue.use(Router);



const router = new Router({

  scrollBehavior: (to, from, savedPosition) => {

    if (savedPosition) {

      return savedPosition;

    }

    return { x: 0, y: 0 };

  },

  base: process.env.BASE_URL,

  routes: [

    {

      path: "/login",

      component: () =>

        import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),

      meta: { title: "管理后台", hidden: true, notNeedAuth: true }

    },

    {

      path: "/404",

      component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue"),

      meta: { title: "管理后台", hidden: true, notNeedAuth: true }

    },

    {

      path: "/record",

      component: () =>

        import(/* webpackChunkName: "record" */ "@/views/record/index.vue"),

      meta: { title: "个人日志", hidden: true, notNeedAuth: true }

    },

    {

      path: "/",

      component: Layout,

      redirect: "/mpUser",

      children: [

        {

          path: "mpUser",

          component: () =>

            import(/* webpackChunkName: "mpUser" */ "@/views/mpUser/index.vue"),

          meta: {

            title: "小程序用户",

            icon: "icon-employee"

          }

        },

        {

          path: "mpRole",

          component: () =>

            import(/* webpackChunkName: "mpRole" */ "@/views/mpRole/index.vue"),

          meta: {

            title: "角色权限",

            icon: "icon-category"

          }

        },

        {

          path: "employee",

          component: () =>

            import(/* webpackChunkName: "employee" */ "@/views/employee/index.vue"),

          meta: {

            title: "员工管理",

            icon: "icon-employee"

          }

        },

        {

          path: "billAppLog",

          component: () =>

            import(/* webpackChunkName: "billAppLog" */ "@/views/billAppLog/index.vue"),

          meta: {

            title: "青山记账日志",

            icon: "icon-order"

          }

        },

        {

          path: "/employee/add",

          component: () =>

            import(/* webpackChunkName: "employee" */ "@/views/employee/addEmployee.vue"),

          meta: {

            title: "添加员工",

            hidden: true

          }

        }

      ]

    },

    {

      path: "*",

      redirect: "/404",

      meta: { hidden: true }

    }

  ]

});



export default router;

